import * as Yup from 'yup'

export const schema = Yup.object().shape({
  action: Yup.string().required('Action name is required'),
  model_type: Yup.object().required('Model type is required').nullable(),
});